export default "__VITE_ASSET__3fc1fd47__"